module.exports = __webpack_public_path__ + "files/8ea137703f3f465be8753ab7b6874090.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/sourcesanspro-bolditalic-webfont.ttf
 ** module id = 1017
 ** module chunks = 0
 **/